const PaymentUtils = {
    generate_order_id: () => {
        const timestamp = Math.floor(Date.now() / 1000); // Get current timestamp in seconds
        const randomChars = [...Array(5)].map(() => Math.random().toString(36).charAt(2).toUpperCase()).join(''); // Generate 5 random capitalized alphanumeric characters
        const paymentId = `PAY-${timestamp}-${randomChars}`; // Construct the unique ID
        return paymentId;
    }
}

export default PaymentUtils